export const PROGRAM_PAGES = {
  "food-pantry": {
    title: "Food & Street Outreach",
    image: "/images/pantry-food/3.jpg",
    imageContain: true,
    mission:
      "We bring food and comfort directly to people where they are — delivering to families' homes and reaching neighbors living on the streets of Osceola County.",
    whatWeDo: [
      "Deliver packaged food boxes to families' homes",
      "Bring food and blankets to people living on the streets",
      "Meet neighbors where they are, with dignity and kindness",
      "Working toward opening a food pantry in Kissimmee (coming soon)",
    ],
  },
  "family-disability-support": {
    title: "Family & Disability Support",
    image: "/images/family-support/1.jpg",
    imageContain: true,
    mission:
      "We have a special heart for families facing extra challenges — children with autism, people living with MS, seniors, and low-income families. Our goal is to make life a little lighter for those who need it most.",
    whatWeDo: [
      "Connect families with helpful resources and practical, hands-on support",
      "Provide supplies and everyday essentials to families in need",
      "Show up with encouragement so no one has to face hard seasons alone",
      "Keep all of our support completely free for the families we serve",
    ],
    gallery: [
      { src: "/images/family-support/2.jpg", caption: "Sharing a smile with one of the seniors we visit." },
      { src: "/images/family-support/3.jpg", caption: "Spending time together over a favorite pastime." },
      { src: "/images/family-support/4.jpg", caption: "Visiting neighbors at their senior community." },
    ],
  },
  "clothing-toys-supplies": {
    title: "Clothes, Toys & Supplies",
    image: "/images/toys.jpg",
    mission:
      "Every child deserves to feel loved and remembered. We share toys, clothing, and everyday supplies with children and families who could use a little extra care.",
    whatWeDo: [
      "Give toys to children with autism and children from low-income families",
      "Visit hospitals to bring joy to kids going through a hard time",
      "Collect and hand out clothing, hygiene items, and school supplies",
      "Offer everything we give free of charge to the families we serve",
    ],
  },
  "disaster-relief": {
    title: "Disaster Relief",
    image: "/images/supply-run.jpg",
    comingSoon: true,
    mission:
      "In Florida, a single storm can turn lives upside down. We're working toward being ready to help families get back on their feet when disaster strikes.",
    whatWeDo: [
      "Build up a supply of water, food, and essentials for emergencies",
      "Grow a team of volunteers ready to respond when storms hit",
      "Support neighbors affected by hurricanes and other emergencies",
      "Provide relief free of charge to every family we reach",
    ],
  },
  "community-events": {
    title: "Community & Charity Events",
    image: "/images/community-group.jpg",
    mission:
      "We believe in showing up for our community in person — celebrating together, raising support, and bringing neighbors closer all year long.",
    whatWeDo: [
      "Host and join holiday markets, Christmas events, and fundraisers",
      "Partner with local churches and organizations",
      "Raise support that fuels all of our programs",
      "Keep every community event free and open to all",
    ],
  },
  "international-outreach": {
    title: "International Outreach",
    image: "/images/international.jpg",
    mission:
      "Our heart for helping people doesn't stop at Florida's borders. We work to bring support and hope to families in need around the world.",
    whatWeDo: [
      "Partner with others overseas who share our mission",
      "Help send supplies, support, and hope to communities in need",
      "Stand with families far beyond our own neighborhood",
      "Share everything we give freely, wherever help is needed",
    ],
  },
  "charity-fundraiser-events": {
    title: "Charity Fundraiser Events",
    image: "/images/kia/3.jpg",
    imageContain: true,
    mission:
      "When our community comes together, families in need feel the difference. Our fundraisers and charity events turn a fun day out into real support — bringing neighbors, local partners, and volunteers side by side for a good cause.",
    whatWeDo: [
      "Host fundraisers and charity events throughout the community",
      "Bring neighbors, local partners, and volunteers together for a good cause",
      "Raise support that goes straight to families in need",
      "Keep every event free and welcoming for all who come",
    ],
    hostCta: "Host or Sponsor an Event",
    gallery: [
      { src: "/images/kia/1.jpg", caption: "A volunteer shares a gentle moment with a rescue puppy." },
      { src: "/images/kia/2.jpg", caption: "New friendships forming on the floor at our event." },
      { src: "/images/kia/3.jpg", caption: "Neighbors gather around the pen to meet the pups." },
      { src: "/images/kia/4.jpg", caption: "Getting to know the littlest guests up close." },
      { src: "/images/kia/5.jpg", caption: "A warm hello to one of the rescues." },
      { src: "/images/kia/7.jpg", caption: "Capturing happy memories with a four-legged friend." },
      { src: "/images/kia/8.jpg", caption: "A loving hug for a rescue pup." },
    ],
  },
};
